module.exports = __webpack_public_path__ + "static/media/Untitled-1.08ef25b5.webp";